import React, {useRef, useState, useEffect} from "react";
import {graphql} from "gatsby";
import { Link } from "../../../../plugins/gatsby-plugin-atollon";
import parse from "html-react-parser";
import StructuredText from "../custom-structured-text-renderer";
import FormComponent from "../../form";

const Promo = ({title, subHeading, products, promoTermsConditions, form, theme}) => {

  const [promoTitle, setPromoTitle] = useState('');

  useEffect(() => {
    // if window exists
    let promo = '';
    if (typeof window !== `undefined`) {
      promo = window.location.pathname
    }
    setPromoTitle(parse(promo));
  }, []);

  return (
    <section className={`promo ${theme || ''}`}>
      <div className='promo__inner'>
        <div className='promo__wrapper'>
          <div className='promo__content'>
            {title && <h1>{parse(title)}</h1>}
            {subHeading && <div className='promo__heading'><StructuredText data={subHeading}/></div>}
            { products?.length > 0 && 
              <ul className='promo__products'>
                {products.map((product, index) => (
                  <li key={index}>
                    <Link to={product.permalink}>
                      <span>{parse(product.title.replace(product.size, ''))}</span>
                      <span>{product.size}</span>
                    </Link>
                  </li>
                ))}
              </ul>
            }
            {promoTermsConditions && <div className='promo__terms'><p>{parse(promoTermsConditions)}</p></div>}
          </div>
          <div className='promo__form' data-lenis-prevent>
            {form?.length > 0 && <FormComponent promoTitle={promoTitle} form={form[0].form}/>}
          </div>        
        </div>
      </div>
    </section>
  )
}

export default Promo

export const query = graphql`
fragment PromoProps on DatoCmsPromo {
  ... on DatoCmsPromo {
    id
    title
    subHeading {
      value
    }
    products {
      ... on DatoCmsEdlynProduct {
        originalId
        title
        brand
        permalink
        size
      }
      ... on DatoCmsBoneProduct {
        originalId
        title
        brand
        permalink
        size
      }
      ... on DatoCmsWoodsProduct {
        originalId
        title
        brand
        permalink
        size
      }
      ... on DatoCmsGreenwheatProduct {
        originalId
        title
        brand
        permalink
        size
      }
    }
    form {
      form {
        ...FormProps
      }
    }
    promoTermsConditions
  }
}
`